<template>
  <ui-detail-view
    class="two-columns"
    model="song-work"
    model-path="SongWorks/model-config/register.js"
    :set-model-data-fn="setModelDataFn"
    :action-config="
      getSubmitActionConfig('提交报名', { class: 'register-button' })
    "
    to="custom"
  >
    <template #before-form-item="{ config }">
      <h4 class="from_msg_tit" v-if="config.slot === 'section'">{{ config.title }}</h4>
      <div class="from_msg_msg" v-if="config.slot === 'msg'">{{ config.title }}</div>
    </template>
    <template #after-form-item="{ config: { agreement } }">
      <ui-alert v-if="agreement" class="agreement" state="info">{{
        agreement
      }}</ui-alert>
    </template>

    <template #after-item__file--songFile>
      <ui-textfield-helper visible
        >支持的拓展名：mp3，不超过10M</ui-textfield-helper
      >
    </template>
    <template #after-item__file--songLryic>
      <ui-textfield-helper visible
        >支持的拓展名：doc docx pdf jpg png rar
        zip，不超过10M</ui-textfield-helper
      >
    </template>
  </ui-detail-view>
</template>

<script>
import workDetailMixin from "@/mixins/work-detail.js";
import { getSubmitActionConfig } from "@/components/pro-views/config";

export default {
  name: "SongWorksWorkDetail",
  mixins: [workDetailMixin],
  methods: {
    getSubmitActionConfig,
  },
};
</script>
